import type { Machine } from '@atlassian/state-machine/types';

export function untilInState<T extends string>(
  machine: Machine<T, any, any, any>,
  ...states: T[]
) {
  if (states.includes(machine.state())) {
    return Promise.resolve(machine.state());
  }

  return new Promise<T>((resolve) => {
    machine.onTransition((_ev, _ctx, { current }) => {
      if (states.includes(current)) {
        resolve(current);
      }
    });
  });
}
